import script from "./AdventureChatSessionDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureChatSessionDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AdventureChatSessionDrawer.vue?vue&type=style&index=0&id=72f2f23e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f2f23e"]])

export default __exports__